/**
 * @file useDocumentTitle.js
 * @description Sets document.title for the current page (COL-134).
 *
 * Every Task Manager surface should own its title so navigating between
 * modules (e.g. Post Grant Support → OA Shell) updates the browser tab
 * instead of leaving a stale title from the previously visited module.
 *
 * Resets to the app default on unmount so any page that doesn't call this
 * hook (or sets no title) falls back to "Trexo Global" instead of inheriting
 * whatever title the last visited page left behind.
 */

import { useEffect } from "react";

export const DEFAULT_TITLE = "Trexo Global";

/**
 * @param {string} title - the document title to apply while mounted
 */
export const useDocumentTitle = (title) => {
    useEffect(() => {
        document.title = title || DEFAULT_TITLE;
        return () => {
            document.title = DEFAULT_TITLE;
        };
    }, [title]);
};

export default useDocumentTitle;
